export const initAmplitude = () => {
    if (process.env.NODE_ENV !== "development") {
      amplitude.getInstance().init(process.env.AMPLITUDE_APP_KEY)
    }
  }
  export const sendAmplitudeData = (eventType, eventProperties = {}) => {
    amplitude.getInstance().logEvent(eventType, eventProperties)
  }